
<div class="confirmation-cont">
  <div class="confirmation" v-if="!getAllInfos.restoAutoAccept" style="margin-top: 32px;">
    <p>Votre réservation a été soumise au restaurateur.</p>
    <p>Une fois votre réservation validée un email de confirmation vous sera envoyé.</p>
    <p>IMPORTANT: Si vous ne recevez pas nos emails, merci de vérifier vos spams ou l'onglet Promotions sur Gmail.</p>
    <p>Bonne journée !</p>
  </div>
  <div class="confirmation" v-else-if="getAllInfos.restoAutoAccept" style="margin-top: 54px;">
    <p v-if="getAllInfos.resaConfirmMessage" v-html="renderMarkdown(getAllInfos.resaConfirmMessage)"></p>
    <p v-else>
      Bravo ! <br />Votre réservation est acceptée par le restaurateur.
    </p>
    <p>Nous vous attendons donc le <b>{{ getSelectedDateObject.labelDay }} {{ getSelectedDateObject.day }}
        {{ getSelectedDateObject.labelMonth }} {{ getSelectedDateObject.year }} à {{ getSelectedService.hour }}</b>
      pour
      <b>{{ getNbCouvert }} couvert(s).</b>
    </p>
    <p>Bonne journée !</p>
  </div>
  <!-- <el-button 
    class="booking-button"
    @click="resetForkBooking()"
  >
    Réserver à nouveau
  </el-button> -->
</div>
